"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _excluded = ["onFocus", "eagerLoad"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PaginatedAssetGroupFilter = function PaginatedAssetGroupFilter(_ref) {
  var onFocus = _ref.onFocus,
      eagerLoad = _ref.eagerLoad,
      props = _objectWithoutProperties(_ref, _excluded);

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _useState = (0, _react.useState)(eagerLoad),
      _useState2 = _slicedToArray(_useState, 2),
      enabled = _useState2[0],
      setEnabled = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      filterTerm = _useState4[0],
      setFilterTerm = _useState4[1];

  var fetchingRef = (0, _react.useRef)(false);

  var _usePortalAssetGroups = (0, _hooks.usePortalAssetGroupsPaginated)(portalId, {
    enabled: Boolean(portalId) && enabled,
    filter: filterTerm
  }),
      data = _usePortalAssetGroups.data,
      fetchNextPage = _usePortalAssetGroups.fetchNextPage,
      hasNextPage = _usePortalAssetGroups.hasNextPage,
      isFetchingNextPage = _usePortalAssetGroups.isFetchingNextPage;

  (0, _react.useEffect)(function () {
    if (!isFetchingNextPage) {
      fetchingRef.current = false;
    }
  }, [isFetchingNextPage]);
  var handleFocus = (0, _react.useCallback)(function () {
    setEnabled(true);
    onFocus();
  }, [onFocus]);
  var handleQueryChange = (0, _react.useCallback)(function (query) {
    setFilterTerm(query);
  }, []);
  var handleFetchMore = (0, _react.useCallback)(function () {
    if (fetchingRef.current) return;
    fetchingRef.current = true;
    fetchNextPage();
  }, [fetchNextPage]);
  var source = (0, _react.useMemo)(function () {
    var _data$pages;

    var pages = (_data$pages = data === null || data === void 0 ? void 0 : data.pages) !== null && _data$pages !== void 0 ? _data$pages : [];
    var allGroups = pages.flatMap(function (p) {
      return p.assetGroups;
    });
    return allGroups.reduce(function (result, group) {
      var nextResult = result;
      nextResult[group.id] = group.name;
      return nextResult;
    }, {});
  }, [data]);
  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, _extends({}, props, {
    source: source,
    debounceTime: 400,
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.AssetGroup, null),
    valueType: "Integer",
    onFocus: handleFocus,
    onQueryChange: handleQueryChange,
    canFetchMore: hasNextPage,
    fetchMore: handleFetchMore,
    isFetchingMore: isFetchingNextPage
  }));
};

PaginatedAssetGroupFilter.propTypes = _objectSpread(_objectSpread({}, _nicbaseForms.Autocomplete.propTypes), {}, {
  onFocus: _propTypes["default"].func,
  eagerLoad: _propTypes["default"].bool
});
PaginatedAssetGroupFilter.defaultProps = _objectSpread(_objectSpread({}, _nicbaseForms.Autocomplete.defaultProps), {}, {
  onFocus: function onFocus() {},
  eagerLoad: false
});
var _default = PaginatedAssetGroupFilter;
exports["default"] = _default;